import { useMessageApi } from '../../../../provider/AntdNotification';
import { useDeleteBlog, useListBlog } from '../../../../hooks/api/blog/hook';
import { IBlogPayload } from '../../../../types/api/blog';
import React, { useMemo } from 'react'
import { useQueryState } from 'nuqs';
import ButtonWrapper from '../../../../views/components/reuseComp/ButtonWrapper';
import BlogForm from './BlogForm';
import BlogTable from './BlogTable';

const BlogComp: React.FC<{allowURLStateUpdate?: boolean}> = ({ allowURLStateUpdate  = true}) => {
  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const message = useMessageApi()
  

  const [mode, setMode] = useQueryState("mode", { defaultValue: "view" });
  const [sectionId, setSectionId] = useQueryState("id");

  const isCreatePage = mode === "create";
  const isEditPage = mode === "edit" && !!sectionId;

   const { data, refetchWithQuery: refetch, isFetching } =
      useListBlog({
        page: 1,
        limit: 20,
        ...DEFAULT_NUQS_CONFIG,
      });
  
    const qData = data?.qData ?? { page: 1, limit: 20 };
    const { mutate: deleteFromBlog } = useDeleteBlog({ qData });
    
  
    const blogList: IBlogPayload[] = useMemo(
      () => data?.data || [],
      [data]
    );

     const handleCreateClick = () => {
      setMode("create");
      setSectionId(null);
    };

    const handleEditClick = (id: string) => {
      setMode("edit");
      setSectionId(id);
    };

    const handleCancel = () => {
      setMode("view");
      setSectionId(null);
    };

    const handleDelete = (id: string) => {
      deleteFromBlog(
        { ids: id },
        {
          onSuccess: () => {
            message.success("Blog deleted successfully");
          },
          onError: (err: any) => {
            const msg =
              err?.response?.data?.message ||
              err?.message ||
              "Failed to delete from Blog";

            message.error(msg);
          },
        }
      );
  };



  return (
    <div>
       <div className="flex justify-between items-center">
        <h1 className="text-xl sm:text-3xl  sm:mb-2">
          {isCreatePage || isEditPage ? "Blogs " : "Blogs"}
        </h1>

        {!isCreatePage && !isEditPage && (
          <ButtonWrapper
            className="bg-primary text-white"
            onClick={handleCreateClick}
          >
            Create Blog
          </ButtonWrapper>
        )}


      </div>
       <div className="mt-5">
        {isCreatePage || isEditPage ? (
          <BlogForm qData={qData} id={sectionId} handleCancel={handleCancel} />
        ) : (
          <BlogTable
            data={blogList}
            loading={isFetching}
            refetch={refetch}
            qData={qData}
            handleEditClick={handleEditClick}
            DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
            handleDelete={handleDelete}
          />
        )}
      </div>
    </div>
  )
}

export default BlogComp